module.exports = __webpack_public_path__ + "img/avatar-14.32987607.png";